module.exports = __webpack_public_path__ + "aea4d4f58a8767fe8cca183da974196b.svg";